<template>
  <div class="inline-filters" v-if="!isLoading">
    <div
      v-for="(filterOptions, filterKey, index) in availableFilters"
      :key="index"
    >
      <InlineFilter
        v-if="size(filterOptions)"
        :label="getFilterTitle(filterKey)"
        :filters="filters[filterKey]"
        :options="filterOptions"
        @clear="handleClear(filterKey)"
      >
        <FilterRadio
          :options="filterOptions"
          :selectedValue="filters[filterKey]"
          @change="value => updateFilterFor(filterKey, value)"
        />
      </InlineFilter>
    </div>
  </div>
</template>

<script>
import InlineFilter from "@/components/common/InlineFilter";
import FilterRadio from "@/components/common/FilterRadio";

import { omitBy, isNil, size } from "lodash";

export default {
  components: {
    InlineFilter,
    FilterRadio
  },
  props: {
    isLoading: Boolean,
    outerSelectedFilters: {
      type: Object,
      default: () => ({})
    },
    filterLabels: {
      type: Object,
      default: () => ({})
    },
    availableFilters: Object
  },
  data() {
    return {
      filters: Object.assign({}, this.outerSelectedFilters)
    };
  },
  methods: {
    clearFilters() {
      this.$emit("onClearFilters");
    },
    saveChanges() {
      const formattedFilters = omitBy(this.filters, isNil);
      this.$emit("filter", formattedFilters);
    },
    updateFilterFor(key, value) {
      this.filters = { [key]: value, organisation: value };
      this.saveChanges();
    },
    getFilterTitle(filterName) {
      const label = this.filterLabels[filterName];
      if (label) {
        return label;
      }

      return filterName;
    },
    handleClear(key) {
      this.filters[key] = [];
      this.saveChanges();
    },
    size
  },
  watch: {
    outerSelectedFilters(newValue) {
      if (isNil(newValue)) {
        this.filters = {};
      }
    }
  }
};
</script>

<style lang="scss"></style>
